import './scripts/combodate'
import application from './scripts/application'
import {
    initChecklistStages,
    onSaveAccountForm,
    submit_order_files,
    submit_order_link,
    update_order_data,
    update_order_status,
    update_order_comment,
    remove_document,
    completeStage,
    submitStage,
    enrolledStudent,
    acceptance_offer,
    visa_status,
    visa_upload,
    evaluation_upload, evaluation_status, remove_application, restore_application,
    acceptance_upload
} from './scripts/applications-functions'
import { campusesList } from './scripts/campuses-list'
import studentAcademic from './scripts/student-academic'
import studentAdmission from './scripts/student-admission'
import { loader } from './scripts/loader'
import 'select2'
import { init_funds_validator } from './funds_verification_student';

application()
studentAcademic()
initCombodates()
init_funds_validator()

function initCombodates() {
    $(document).find('.date-field').combodate({
        firstItem: 'name',
        maxYear: 2030,
        minYear: 1990,
        format: 'yyyy-mm-dd'
    }).change(function (e) {
        if (e.target.id === 'appointment_date') {
            let appointment_date = $(this).val();

            let app_id = $(this).closest('.tab-content').find('.visa-status-button__accept').data('application-id');

            $.ajax({
                url: window.glob_obj.ajaxurl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'set_appointment_date',
                    appointment_date: appointment_date,
                    app_id: app_id
                }
            });
        }
    });

}
if (window.applications_page !== undefined) {

    $.ajax({
        url: window.glob_obj.ajaxurl,
        method: 'POST',
        dataType: 'json',
        data: {
            action: 'students_applications_ajax'
        },
        beforeSend: function () {
            loader.show()
        },
        success: function (response) {
            loader.hide()
            $('.application-items.result-content').html(response.html)
            initChecklistStages();
            campusesList.init();
            $(document).find('.application-items .checklist-wrapper .ui-tabs-panel').css({
                'display': 'none',
                'visibility': 'visible',
                'position': 'relative'
            });
            $(document).find('.program-select').select2();
            initCombodates();
            submit_order_files();
            submit_order_link();
            update_order_data();
            update_order_status();
            update_order_comment();
            remove_document();
            completeStage();
            submitStage();
            enrolledStudent();
            acceptance_offer();
            visa_status();
            visa_upload();
            evaluation_upload();
            evaluation_status();
            remove_application();
            restore_application();
            acceptance_upload();

        },
        error: function (error) {
            loader.hide()
            console.log(error);
        }
    });

}

$('#edit-account-form').submit(function (e) {
    e.preventDefault();
    loader.show();
    onSaveAccountForm()
    this.submit();
});

$('#edit-academic-form').submit(function (e) {
    e.preventDefault();
    loader.show();
    this.submit();
});

$(document).find('.date-field').combodate({
    firstItem: 'name',
    maxYear: 2030,
    minYear: 1970,
    format: 'yyyy-mm-dd'
});

$('#reset-academic-info').click(function (e) {
    e.preventDefault();

    $.ajax({
        url: window.glob_obj.ajaxurl,
        method: 'POST',
        dataType: 'json',
        data: {
            action: 'reset_academic_info',
            _ajax_nonce: window.glob_obj.reset_academic_info_nonce
        },
        beforeSend: function () {
            loader.show()
        },
        success: function (response) {
            if (response.success) {
                location.reload();
                return false;
            }
        },
        error: function (error) {
            loader.hide()
            console.log(error);
        }
    });
})


if (window.admission_form !== undefined) {
    studentAdmission();
}

window.onload = function () {
    var widget = {
        'id': 'root',
        'widget_id': '86ce6ab2-9d2a-49c8-8063-d0e6200e8f36'
    };

    function serialize(obj) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
        return str.join("&");
    }

    function getWidget() {
        var hostPath = `${window.location.origin}${window.location.pathname}`;
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            widget[key] = value;
        });
        widget['host_information'] = hostPath;
        widget['host_name'] = hostPath;
        return widget;
    }

    var iframe = document.getElementById(widget['widget_id']);
    if (iframe) {
        iframe.src = `${iframe.src}?${serialize(getWidget())}`
    }

}
